<template>
	<div class="no-goals-placeholder__container">
		<div class="no-goals-placeholder__icon-container">
			<FontAwesomeIcon
				:icon="[ 'fad', 'bullseye-arrow', ]"
				class="no-goals-placeholder__icon"
			/>
		</div>
		<header class="no-goals-placeholder__header">
			<span v-if="selectedTeamType">
				{{ translate( `${ selectedTeamType }No${ selectedGoalType }GoalsHeaderText` ) }}
			</span>
			<span v-else>
				{{ translate( `no${ selectedGoalType }GoalsHeaderText` ) }}
			</span>
		</header>
		<div class="no-goals-placeholder__description">
			<span v-if="selectedTeamType">
				{{ translate( `${ selectedTeamType }No${ selectedGoalType }GoalsDescriptionText` ) }}
			</span>
			<span v-else>
				{{ translate( `no${ selectedGoalType }GoalsDescriptionText` ) }}
			</span>
		</div>
	</div>
</template>

<script>

export default {
	name: "NoGoalsPlaceholder",
	props: {
		selectedTeamType: {
			type: String,
			default: "",
		},
		selectedGoalType: {
			type: String,
			required: true,
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.NoGoalsPlaceholder.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>
$noGoalsPlaceholderBackgroundColor: $white;
$noGoalsPlaceholderHeaderFontColor: $color1-500;
$noGoalsPlaceholderDescriptionFontColor: $color1-500;
$noGoalsPlaceholderIconColor--primary: $color1-200 ;
$noGoalsPlaceholderIconColor--secondary: $color1-100 ;

.no-goals-placeholder__container {
	padding: 1.5rem;
	background: $noGoalsPlaceholderBackgroundColor;
	border-radius: .5rem;
}

.no-goals-placeholder__header {
	@include font-and-line-for(1);
	color: $noGoalsPlaceholderHeaderFontColor;
	font-weight: 600;
	margin-top: 1.5rem;
}

.no-goals-placeholder__description {
	@include font-and-line-for(0);
	color: $noGoalsPlaceholderDescriptionFontColor;
	margin-top: 1rem;
}

.no-goals-placeholder__icon {
	width: 3.125rem;
	height: 3.125rem;
	--fa-primary-color: #{$noGoalsPlaceholderIconColor--primary};
	--fa-secondary-color: #{$noGoalsPlaceholderIconColor--secondary};
	--fa-secondary-opacity: 1;
}
</style>
